import React from 'react';
import HoldDownQuantity from 'shared/components/pallets/HoldDownQuantity';
import NeedTopHat from 'shared/components/pallets/NeedTopHat';
import NeedStiffenerBar from 'shared/components/pallets/NeedStiffenerBar';
import ThroughHoleQuantity from 'shared/components/pallets/ThroughHoleQuantity';
import {
  holdDownQuantity as holdDownQuantityTooltip,
  needTopHat as needTopHatTooltip,
  needStiffenerBar as needStiffenerBarTooltip,
  shoulderBolts as shoulderBoltsTooltip,
} from 'wave_solder_pallets/data/tooltips';

const Hardware = (props) => {
  const { validator, parameters } = props;
  return (
    <div className="hardware-section">
      <h5 className="hardware-title">Hardware</h5>
      <div className="row">
        <div className="col-12">
          <HoldDownQuantity {...props} label="# of Hold Downs ($3 each)" tooltip={holdDownQuantityTooltip}>
            <span className="error">
              {validator.message(`Hold Down Quantity`, parameters.hold_down_board_quantity, 'required|integer|min:0,num')}
            </span>
          </HoldDownQuantity>
        </div>
        <div className="col-12">
          <NeedTopHat {...props} tooltip={needTopHatTooltip}>
            <span className="error">
              {validator.message(`Need Top Hat`, parameters.pallet_need_top_hat, 'required')}
            </span>
          </NeedTopHat>
        </div>
        <div className="col-12">
          <NeedStiffenerBar {...props} tooltip={needStiffenerBarTooltip}>
            <span className="error">
              {validator.message(`Need Stiffener Bars`, parameters.pallet_need_stiffener_bar, 'required')}
            </span>
          </NeedStiffenerBar>
        </div>
        <div className="col-12">
          <ThroughHoleQuantity {...props} tooltip={shoulderBoltsTooltip} label="How many through-hole components need to be pressed down with shoulder bolts? ($2 each)">
            <span className="error">
              {validator.message(`Through-Hole quantity`, parameters.through_hole_component_pressed_quantity, 'required|integer|min:0,num')}
            </span>
          </ThroughHoleQuantity>
        </div>
      </div>
    </div>
  );
};

export default Hardware;
